import logoAb4cus from '@/assets/images/logo_ab4cus.png'
import { Typography } from '@/components/atoms/Typography/Typography'
import { useTranslation } from 'react-i18next'

const CopyrightSection = (): JSX.Element => {
  const { t } = useTranslation()
  const currentYear = new Date().getFullYear()

  return (
    <div className='bg-white py-8'>
      <div className='container mx-auto px-4'>
        <div className='flex flex-col md:flex-row items-center justify-center gap-2'>
          <Typography variant='p' className='text-[#92989F] text-sm'>
            {t('copyright.text', { year: currentYear })}
          </Typography>
          <div className='hidden md:block text-[#92989F] text-sm'>|</div>
          <div className='flex items-center gap-2'>
            <Typography variant='p' className='text-[#92989F] text-sm'>
              {t('copyright.developedBy')}
            </Typography>
            <img
              src={logoAb4cus}
              alt={t('copyright.ab4cusAlt')}
              className='h-4 w-auto'
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default CopyrightSection
